import { environment } from 'src/environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
export class EnvironmentGuard {
    constructor(router) {
        this.router = router;
    }
    canActivate() {
        if (environment.production) {
            this.router.navigate(['/']);
            return false;
        }
        return true;
    }
}
EnvironmentGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function EnvironmentGuard_Factory() { return new EnvironmentGuard(i0.ɵɵinject(i1.Router)); }, token: EnvironmentGuard, providedIn: "root" });
